import React from 'react';
import styled from 'styled-components';
import { Input, Tooltip } from 'antd';

import 'antd/dist/antd.css';
import wtlLogo from '../images/wtl-logo.png';
import { navigate } from '@reach/router';
import { callApi } from '../../config';
import { faq } from '../data/faq';
import { pinPoints } from '../data/pin-points';

import { Row } from '../components/row';
import { Col } from '../components/col';

const ThePage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  font-family: 'Open Sans', sans-serif;
  background: #ffffff;
  background: -moz-linear-gradient(top,  #ffffff 0%, #f0f0f0 100%);
  background: -webkit-linear-gradient(top,  #ffffff 0%,#f0f0f0 100%);
  background: linear-gradient(to bottom,  #ffffff 0%,#f0f0f0 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f0f0f0',GradientType=0 );
`;

const Body = styled.div`
  padding: 40px 20px;

  .quick-features {
    padding: 20px 0;

    & > div {
      display: inline-flex;
      align-items: center;
      padding: 10px 0;
      font-size: 14px;
      font-weight: bold;
      color: #0e2f63;

      i {
        color: #005bc5;
      }
    }

    i {
      font-size: 32px;
      margin-right: 10px;
    }
  }

  .privacy {
    margin: 10px 0;
    font-size: 13px;

    a {
      color: #000;
      text-decoration: underline;
    }
  }

  .padded-desktop {
    margin-left: 20px;
  }

  @media all and (max-width: 768px) {
    max-width: 600px;
    margin: 0 auto;

    .centre-mobile {
      text-align: center;
    }

    .padded-desktop {
      margin-left: 0;
    }
  }
`;

const PageSizeWrapper = styled.div`
  position: relative;
  max-width: 1200px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  box-sizing: border-box;
`;

const SignUpForm = styled.form`
  .pure-g > div:first-of-type {
    padding: 10px 0;
  }

  .ant-input-group-wrapper {
    margin: 5px 0;
  }
`;

const WtlButton = styled.button`
  appearance: none;
  background-color: rgb(1, 91, 197);
  color: #fff;
  font-weight: normal;
  padding: 12.5px 15px;
  border: solid 1px #fff;
  box-shadow: none;
  transition: background-color 0.3s ease 0s, border 0.6s ease 0s, box-shadow 0.6s ease 0s;
  
  &:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, .5);
    background-color: rgb(47, 125, 216);
  }
`;

const WtlButtonSecondary = styled.button`
  appearance: none;
  background-color: transparent;
  color: rgb(1, 91, 197);
  font-weight: normal;
  padding: 12.5px 15px;
  border: none;
  box-shadow: none;
  transition: color 0.3s;

  &:hover {
    color: rgb(1, 110, 230);
  }
`;

const FaqSection = styled.div`
  @keyframes faqFadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }

    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0px 10px 30px #ccc;
  margin-bottom: 20px;
  animation: faqFadeIn 1s ease-in 1 both;
  opacity: 0;

  .title {
    font-size: 14px;
    font-weight: bold;
    color: #0e2f63;

    i {
      font-size: 14px;
      margin-right: 5px;
    }
  }

  .body {
    padding: 10px;
  }
`;

const ErrorRow = styled(Row)`
  @keyframes shake {
    0% {
      transform: translateX(-10px);
    }

    10% {
      transform: translateX(10px);
    }

    40% {
      transform: translateX(-10px);
    }

    75% {
      transform: translateX(10px);
    }

    100% {
      transform: translateX(0px);
    }
  }

  padding: 5px 0;
  animation: shake .3s linear 1 both;
  color: rgba(255, 120, 30, 255);
`;

export default class Details extends React.Component {
  faqSections = faq;
  state = {
    formErrors: [],
    isSubmittingForm: false,
    accountName: '',
    wtlSchema: (typeof window !== 'undefined' && typeof sessionStorage._wtlshl !== 'undefined') ? JSON.parse(sessionStorage._wtlshl) : null
  };

  async onFormSubmit(form) {
    const email = form.email.value;
    const login = form.login.value;
    const website = form.website.value;
    const password = form.password.value;
    const business = form.business ? form.business.value : undefined;
    const layout = form.layout.value;
    const wtlSchema = typeof window !== 'undefined' ? sessionStorage._wtlshl : false;

    this.setState({ isSubmittingForm: true, formErrors: [] });

    let formErrors = [];

    if (!email || !email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g)) {
      formErrors.push('email');
    }

    if (!login) {
      formErrors.push('login');
    }

    if (!password || password.length < 6) {
      formErrors.push('password'); 
    }

    if (formErrors.length > 0) {
      this.setState({
        formErrors,
        isSubmittingForm: false
      });
      return;
    }

    let businessRequest;

    try {
      businessRequest = await callApi(
        'on-boarding/submit',
        'POST',
        {
          email,
          login,
          password,
          business: wtlSchema ? business : false,
          layout: wtlSchema ? layout : false,
          previewData: wtlSchema,
          service: 'wtl'
        }
      );
    } catch (error) {
      this.setState({
        formErrors: ['api'],
        isSubmittingForm: false
      });
      return;
    }

    const { message, error } = businessRequest;

    if (error) {
      formErrors.push(error);

      this.setState({
        formErrors,
        isSubmittingForm: false
      });

      return;
    }

    this.setState({
      formErrors: [],
      isSubmittingForm: false
    });
    navigate('/success');
  }

  renderError(type, message = '') {
    if (this.state.formErrors.indexOf(type) === -1) {
      return null;
    }

    return (
      <ErrorRow>
        <Col span={9}></Col>
        <Col span={15}>
          <i className="fas fa-exclamation-square"></i> {message}
        </Col>
      </ErrorRow>
    );
  }

  render() {
    const { faqSections  } = this;
    const { wtlSchema, accountName, isSubmittingForm } = this.state;

    return (
      <ThePage>
        <Body>
          <PageSizeWrapper>
            <Row>
              <Col span={12} spanMobile={24} style={{ paddingRight: 20 }}>
                <Row>
                  <Col span={24}>
                    <div className="centre-mobile">
                      <img src={wtlLogo} width="100" style={{ marginBottom: 40 }} />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <div className="centre-mobile">
                      It's all ready to launch!
                    </div>
                  </Col>
                </Row>
                <Row className="quick-features">
                  {pinPoints(wtlSchema ? true : false).map(text => (
                    <Col span={12}>
                      <i className="fas fa-check-circle"></i> {text}
                    </Col>
                  ))}
                </Row>
                <Row style={{ marginTop: 20 }}>
                  <Col span={24}>
                    <h2>
                      Account details
                    </h2>
                  </Col>
                </Row>
                <SignUpForm onSubmit={(e) => {
                  e.preventDefault();
                  
                  this.onFormSubmit(e.target);
                }}>
                  <Row>
                    <Col span={9}>
                      <span>
                        Email address *
                      </span>
                    </Col>
                    <Col span={15}>
                      <Input
                        name="email"
                        type="email"
                        addonBefore={
                          <i className="far fa-envelope"></i>
                        }
                      />
                    </Col>
                  </Row>
                  {this.renderError('email', 'You must provide a valid email address.')}
                  {this.renderError('email-taken', 'Account with this email already exists.')}
                  <Row>
                    <Col span={9}>
                      <span>
                        Account name *
                      </span>
                    </Col>
                    <Col span={15}>
                      <Input
                        name="login"
                        addonBefore={
                          <i className="far fa-user"></i>
                        }
                        onChange={(e) => this.setState({ ...this.state, accountName: e.target.value.substr(0, 50) })}
                      />
                      <Tooltip
                        placement="top"
                        title={
                          <div style={{ textAlign: 'center' }}>
                            You will be able to assign your own domain after creating the account. <br/><br/><i>.wtlstudio.com</i> address is a permanent, free address assigned to your account.
                          </div>
                        }
                      >
                        <Input
                          disabled
                          name="website"
                          addonBefore={
                            <i className="far fa-globe"></i>
                          }
                          addonAfter=".wtlstudio.com"
                          value={accountName.toLowerCase().split(/[\s\„\<\>\#\%\{\}\\\|\^\[\]\`\(\)\!\$\%\&\'\(\)\*\+\,\/\:\;\=\?\@\[\]\.]/gm).filter(Boolean).join('-')}
                        />
                      </Tooltip>
                    </Col>
                  </Row>
                  {this.renderError('login', 'You must specify an account name.')}
                  {this.renderError('login-taken', 'Account assigned to this name already exists.')}
                  <Row>
                    <Col span={9}>
                      <span>
                        Password *
                      </span>
                    </Col>
                    <Col span={15}>
                      <Input
                        name="password"
                        type="password"
                        addonBefore={
                          <i className="far fa-lock-alt"></i>
                        }
                      />
                    </Col>
                  </Row>
                  {this.renderError('password', 'You must create a valid password. Min. 6 characters.')}
                  {wtlSchema && (
                    <Row>
                      <Col span={9}>
                        <span>
                          Connected Business
                        </span>
                      </Col>
                      <Col span={15}>
                        <Input
                          disabled
                          name="business"
                          value={(wtlSchema.meta.name || 'Unspecified').trim()}
                          addonBefore={
                            <i className="far fa-store"></i>
                          }
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col span={9}>
                      <span>
                        Layout theme
                      </span>
                    </Col>
                    <Col span={15}>
                      <Input
                        disabled
                        name="layout"
                        value={wtlSchema ? 'WTL Startup Light' : 'Clean Template'}
                        addonBefore={
                          <i className="far fa-paint-brush-alt"></i>
                        }
                      />
                    </Col>
                  </Row>
                  {this.renderError('api', 'Oops, something went wrong. Try again.')}
                  <Row>
                    <Col span={24}>
                      <div className="privacy">
                        By creating an account and a website you accept WTL <a href="https://wtlstudio.com/privacy" target="_blank">privacy policy</a> and <a href="https://wtlstudio.com/privacy#terms-and-conditions" target="_blank">terms and conditions</a>.
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ textAlign: 'right', marginBottom: 40 }}>
                      <div className="centre-mobile">
                        <WtlButtonSecondary onClick={(e) => {
                          e.preventDefault();

                          navigate('/');  
                        }}>
                          Back
                        </WtlButtonSecondary>
                        <WtlButton
                          disabled={isSubmittingForm}
                        >
                          Create Account
                          {
                            isSubmittingForm ?
                              <i className="far fa-spinner-third fa-spin" style={{ marginLeft: 10 }}></i> :
                              <i className="far fa-chevron-right" style={{ marginLeft: 10 }}></i>
                          }
                        </WtlButton>
                      </div>
                    </Col>
                  </Row>
                </SignUpForm>
              </Col>
              <Col span={12} spanMobile={24}>
                <div class="padded-desktop">
                  {
                    faqSections(wtlSchema ? true : false).map((section, index) => (
                      <FaqSection style={{ animationDelay: `${(index + 1) * .3}s` }}>
                        <div className="title">
                          <i className={`${'far'} fa-comments-alt`}></i> {section.title}
                        </div>
                        <div className="body">
                          {section.body}
                        </div>
                      </FaqSection>
                    ))
                  }
                </div>
              </Col>
            </Row>
          </PageSizeWrapper>
        </Body>
      </ThePage>
    );
  }
}
